import { action } from 'satcheljs';
import { OWAConnectedAccount, AccountProviderType } from './schema/OWAConnectedAccount';

/**
 * Initializes the OWA Account Store.
 * The store responds by loading the existing connected accounts from the user's mailbox.
 */
export const initializeOwaAccountsStore = action('initializeOwaAccountsStore');

/**
 * Adds an account to the store.
 * The store responds by loading the user configuration of this account.
 */
export const addOWAConnectedAccount = action('addAccount', (account: OWAConnectedAccount) => ({
    primarySmtpAddress: account.primarySmtpAddress,
    account,
}));

/**
 * Removes an account to the store.
 */
export const removeOWAConnectedAccount = action('removeAccount', (primarySmtpAddress: string) => ({
    primarySmtpAddress,
}));

/**
 * Connect a new account for OWA
 */
export const connectOWAAccount = action(
    'connectAccount',
    (accountProviderType: AccountProviderType) => ({
        accountProviderType,
    })
);

/**
 * Disconnect an account for OWA
 */
export const disconnectOWAAccount = action('disconnectAccount', (account: OWAConnectedAccount) => ({
    account,
}));

/**
 * Updates an account to the store.
 */
export const updateOWAConnectedAccountToken = action(
    'updateAccount',
    (primarySmtpAddress: string, accountToken: string, accountTokenExpiresIn: string) => ({
        primarySmtpAddress: primarySmtpAddress,
        accountToken: accountToken,
        accountTokenExpiresIn: accountTokenExpiresIn,
    })
);

/**
 * Set the flag to denote accounts store is initialized
 */
export const setAccountStoreInitialized = action(
    'setAccountStoreInitialized',
    (initialized: boolean) => ({
        initialized,
    })
);
